import React from 'react'
import Headerbar  from "./components/common/Headerbar";

const Loading = () => {
  return (
    <><Headerbar /><div style={{display:'grid', justifyContent:'center', alignItems:'center', height:'calc(100vh - 7rem)'}}><div className="loader"></div></div></>
  )
}

export default Loading